<button class="ms-login" (click)="loginClick()">
  <img src="assets/svg/ms-symbollockup_mssymbol_19.svg" alt="microsoft-button">
  <span>Sign in with Microsoft</span>
</button>
<mat-error class="signin-button-error" *ngIf="error">{{ error }}</mat-error>
